export default "__VITE_ASSET__dc9b3a35__"